import { useState } from 'react';
import { useApi, useConsulta } from '@plataforma/web/api';
import { fechaCorta } from '../formato';
import { ESTADO_LEAD, fechaHora, type Lead, useFiltro } from './comercial-comun';

// --- Leads -----------------------------------------------------------------------------------

/** Bandeja de leads: preguntas, citas y apartados de la tienda y del marketplace. */
export function Leads() {
  const api = useApi();
  const [estado, poner] = useFiltro();
  const lista = useConsulta<Lead[]>(`/commerce/leads${estado ? `?estado=${estado}` : ''}`);
  const [error, setError] = useState<string | null>(null);
  const seguir = async (l: Lead, cambio: Partial<Pick<Lead, 'estado' | 'nota'>>) => {
    setError(null);
    try {
      await api('POST', `/commerce/leads/${l.id}/seguimiento`, cambio);
      lista.recargar();
    } catch (e) {
      setError((e as Error).message);
    }
  };
  return (
    <>
      <div className="encabezado">
        <div>
          <h1>Leads</h1>
          <div className="subtitulo">
            Compradores que escribieron desde tu tienda o el marketplace
          </div>
        </div>
      </div>
      {error && <p className="error">{error}</p>}
      <section className="seccion">
        <header>
          <select value={estado} onChange={(e) => poner(e.target.value)} aria-label="Estado">
            <option value="">Todos</option>
            {Object.entries(ESTADO_LEAD).map(([c, t]) => (
              <option key={c} value={c}>
                {t}
              </option>
            ))}
          </select>
        </header>
        {lista.datos && !lista.datos.length ? (
          <p className="vacio">Sin leads por ahora.</p>
        ) : (
          <table>
            <tbody>
              {(lista.datos ?? []).map((l) => (
                <tr key={l.id}>
                  <td>
                    <strong>{l.nombre}</strong> · {l.tipo}
                    {l.fechaCita ? ` para el ${fechaCorta(l.fechaCita)}` : ''}
                    <div>{l.mensaje}</div>
                    <div className="vin">
                      {[l.telefono, l.correo].filter(Boolean).join(' · ')} ·{' '}
                      {l.publicacionTitulo ?? 'sin publicación'} · {l.origen}
                      {l.canal ? ` (${l.canal})` : ''} · {fechaHora(l.creadoEn)}
                    </div>
                    {l.nota && <div className="subtitulo">Nota: {l.nota}</div>}
                  </td>
                  <td>
                    <span className={`etiqueta ${l.estado === 'nuevo' ? 'aviso' : ''}`}>
                      {ESTADO_LEAD[l.estado]}
                    </span>
                  </td>
                  <td className="num">
                    <select
                      aria-label={`Estado de ${l.nombre}`}
                      value={l.estado}
                      onChange={(e) => void seguir(l, { estado: e.target.value as Lead['estado'] })}
                    >
                      {Object.entries(ESTADO_LEAD).map(([c, t]) => (
                        <option key={c} value={c}>
                          {t}
                        </option>
                      ))}
                    </select>{' '}
                    <button
                      className="boton"
                      onClick={() => {
                        const nota = window.prompt('Nota de seguimiento', l.nota ?? '');
                        if (nota !== null) void seguir(l, { nota });
                      }}
                    >
                      Nota
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </>
  );
}
